import styled from 'styled-components';
import { maxDevice } from '~/styles/breakpoints';
import map from '~/assets/images/map.svg';

export const Container = styled.footer`
    position: relative;
    overflow: hidden;
    background-image: url(${map});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    &::before {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(10, 10, 10, 0.92);
    }
`;

export const Content = styled.div`
    position: relative;
    z-index: 2;
    min-height: 350px;
    width: 100%;
    max-width: 1150px;
    margin: auto;

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    @media ${maxDevice.laptop} {
        grid-template-columns: 1fr;
    }
`;

export const FooterCollumn = styled.div`
    padding: 35px 20px;

    img {
        max-height: 56px;
        margin-bottom: 20px;
    }

    p {
        font-family: 'Open Sans', Arial, Helvetica, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: normal;
        line-height: 28px;

        color: #fff;
    }

    p + p {
        margin-top: 10px;
    }
`;

export const FooterBottom = styled.div`
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
`;

export const FooterCopyright = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1150px;
    margin: 0 auto;

    padding: 20px 15px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    color: #999;

    p > a {
        margin-left: 5px;
        color: #03a9f4;
    }

    .social-container > a {
        font-size: 16px;
        margin-left: 15px;
        color: #03a9f4;
    }
`;
